import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Manager, Reference, Popper } from 'react-popper';
import styles from './popover.scss';
import Closeable from '../Utilities/Closeable';
import Typography from '../Typography';

const Popover = ({ children, align, content, title }) => {
  const cx = classnames.bind(styles);
  const [visible, setVisible] = useState(false);

  const { Text } = Typography;

  return (
    <span
      className={cx('popover')}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <Manager>
        <Reference>{({ ref }) => <span ref={ref}>{children}</span>}</Reference>
        <Popper placement={align}>
          {({ ref, style, placement }) =>
            visible && (
              <div
                className={cx('popover_wrapper')}
                ref={ref}
                style={style}
                data-placement={placement}
              >
                <div className={cx('popover_wrapper_closeable')}>
                  <Closeable onClick={() => setVisible(false)} />
                </div>

                {title && (
                  <Text small bold>
                    {title}
                  </Text>
                )}

                {content}
              </div>
            )
          }
        </Popper>
      </Manager>
    </span>
  );
};

Popover.defaultProps = {
  align: 'top',
  title: null,
};

Popover.propTypes = {
  align: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),
  children: PropTypes.element.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  title: PropTypes.string,
};

export default Popover;
